import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledDefaultFlyout = styled.div`
  position: relative;
  margin: ${toRem(16)};
  height: auto;

  .separator {
    box-sizing: border-box;
    height: ${toRem(1)};
    border: ${toRem(1)} solid ${color.neutral20};
    margin-bottom: ${toRem(4)};
  }

  .t-label-alt-s {
    line-height: ${toRem(20)};
    font-weight: ${font.fontWeightRegular};
  }

  .main {
    height: 100%;
    @media ${baseVariables.mediaQuery.lg} {
      max-height: ${toRem(348)};
      padding: inherit;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: ${toRem(18)};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${color.neutral20};
        border-radius: ${toRem(10)};
        border: ${toRem(5)} solid ${color.base20};
      }
      ::-webkit-scrollbar-track {
        background-color: ${color.base20};
        margin: ${toRem(10)} 0;
      }
    }
  }

  .footer {
    position: relative;
    background-color: ${color.base20};

    z-index: 1;
    @media ${baseVariables.mediaQuery.lg} {
      padding: unset;
      box-shadow: unset;
      border-bottom: none;
    }
  }
  .clear-recent-cta {
    @media ${baseVariables.mediaQuery.lg} {
      margin-top: ${toRem(8)};
      margin-left: ${toRem(8)};
    }
    background: transparent;
    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }
`;
